import {useCallback, useEffect, useState} from "react";
import {apiEndpoint, useUser} from "@/components/Providers/JWTProvider.tsx";

export type MyFeeQuestion = {
    id: string;
    question: string;
    sortOrder: number;
    responseType: string;
};

export type MyFee = {
    id: string;
    shortCode: string | null;
    name: string;
    description: string;
    type: string;
    isDonation: boolean;
    schoolYear: string;
    school: {
        shortName: string;
        fullName: string;
    };
    accountCode: string | null;
    secondaryAccountCode: string | null;
    questions: MyFeeQuestion[];
};

export const useMyFees = () => {
    const [myFees, setMyFees] = useState<MyFee[]>([]);
    const [error, setError] = useState<string | undefined>();
    const {user, isEmployee} = useUser();
    const fetchData = useCallback(async (): Promise<void> => {
        setError(undefined);
        if (!(user && isEmployee)) {
            setError("Invalid User");
            setMyFees([]);
            return;
        }

        try {
            const url = new URL("/v1/myFees/", apiEndpoint);
            const result = await user.apiFetch(url);

            if (!result.ok) {
                setError("Error Fetching your Fees");
            }

            setMyFees(await result.json());
        } catch (e) {
            console.error("useMyFees", e);
            setError("Error Fetching your Fees");
            setMyFees([]);
        }
    }, [user]);

    useEffect(() => {
        fetchData().catch(e => {
            console.error(e);
            setError("Error Fetching your Fees");
        });
    }, []);

    return {
        myFees,
        error,
        fetchData,
    };
};
